import { render, staticRenderFns } from "./SalemaneMessageList.vue?vue&type=template&id=f95691b2&scoped=true&"
import script from "./SalemaneMessageList.vue?vue&type=script&lang=js&"
export * from "./SalemaneMessageList.vue?vue&type=script&lang=js&"
import style0 from "./SalemaneMessageList.vue?vue&type=style&index=0&id=f95691b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95691b2",
  null
  
)

export default component.exports